module.exports = __webpack_public_path__ + "img/youtube.5a422769.svg";